
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("UK5pP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $223df06c30c2a8bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $223df06c30c2a8bb$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Agregar dados',
    'extension.charts.aggregateDataDescription': "Combine valores em um ponto de dados \xfanico quando linhas m\xfaltiplas tiverem o mesmo valor.",
    'extension.charts.category': 'Categoria',
    'extension.charts.customizeTab': 'Personalizar',
    'extension.charts.dataMissing.details': "N\xe3o foi poss\xedvel encontrar a tabela de origem deste gr\xe1fico na p\xe1gina.",
    'extension.charts.dataMissing.title': "N\xe3o h\xe1 dados dispon\xedveis para exibi\xe7\xe3o",
    'extension.charts.dataTab': 'Dados',
    'extension.charts.defaultColumnName': 'Coluna {0}',
    'extension.charts.defaultTitle': "Gr\xe1fico sem t\xedtulo",
    'extension.charts.defaultYLabel': "Eixo sem t\xedtulo",
    'extension.charts.extensionTitle': "Gr\xe1fico",
    'extension.charts.height': "Altura da \xe1rea do gr\xe1fico",
    'extension.charts.height.large': 'Mais alto',
    'extension.charts.height.medium': "Padr\xe3o",
    'extension.charts.height.small': 'Mais baixo',
    'extension.charts.horizontal.orientation.label': 'Horizontal',
    'extension.charts.insert.tooltip': "Inserir gr\xe1fico",
    'extension.charts.legend': 'Legenda',
    'extension.charts.legend.auto': "Autom\xe1tico",
    'extension.charts.legend.bottom': 'Parte inferior',
    'extension.charts.legend.left': 'Esquerda',
    'extension.charts.legend.position': "Posi\xe7\xe3o de legenda",
    'extension.charts.legend.right': 'Direita',
    'extension.charts.legend.show': 'Mostrar legenda',
    'extension.charts.legend.top': 'Parte superior',
    'extension.charts.options.label': "Op\xe7\xf5es do gr\xe1fico",
    'extension.charts.options.tooltip': "Alterar as op\xe7\xf5es do gr\xe1fico",
    'extension.charts.orientation.label': "Orienta\xe7\xe3o",
    'extension.charts.seriesNames': "S\xe9rie de dados",
    'extension.charts.showPoints': 'Mostrar pontos de dados',
    'extension.charts.smoothLines': 'Linhas suaves',
    'extension.charts.style': 'Estilo',
    'extension.charts.title': "T\xedtulo",
    'extension.charts.type.bar': 'Barra',
    'extension.charts.type.fieldDescription': "Tipo de gr\xe1fico",
    'extension.charts.type.line': 'Linha',
    'extension.charts.type.pie': 'Em pizza',
    'extension.charts.userTitle': "T\xedtulo",
    'extension.charts.vertical.orientation.label': 'Vertical',
    'extension.charts.xAxis': 'Eixo x',
    'extension.charts.xLabel': 'Categoria do eixo X',
    'extension.charts.yLabel': "R\xf3tulo de eixo Y"
};

});


//# sourceMappingURL=pt_BR.a9c23907.js.map
